import React from 'react';
import { Card, CardContent } from '@mui/material';
import { NewReleases as NewReleasesIcon } from '@mui/icons-material';
import ResourcesSearchTab from './ResourcesSearchTab';
import { SEARCH_TAB } from '../constants/resourceTabs';
import { useFilterResourcesByTab } from '../hooks/useFilterResourcesByTab';
import { useShownResources } from '../ResourceStore';
import { useShallow } from 'zustand/shallow';

/**
 * @typedef {object} ResourcesSectionProps
 * @property {Array<*>} resources
 * @property {string} activeTab
 */

/**
 * @param {ResourcesSectionProps} props
 */
const ResourcesSection = props => {
  const { resources, activeTab } = props;

  const shownResources = useShownResources(useShallow(state => state.shownResources));

  const isSearchTab = SEARCH_TAB.value === activeTab;

  useFilterResourcesByTab(resources, activeTab);

  return (
    <>
      {isSearchTab && <ResourcesSearchTab resources={resources} />}
      <div className='resource-cards' data-testid='resource-cards'>
        {!shownResources.length && <p>No results found.</p>}
        {shownResources.map(resource => (
          <Card
            key={resource.resourceId}
            role='card'
            onClick={() => window.open(resource.link, '_blank')}>
            <CardContent>
              <h4 className='resource-tab-name'>
                {resource.hasReleaseIcon && (
                  <NewReleasesIcon data-testid='releaseIcon' className='new-release' />
                )}
                {resource.tab}
              </h4>
              <h3>{resource.title}</h3>
              <p>{resource.description}</p>
            </CardContent>
          </Card>
        ))}
      </div>
    </>
  );
};

export default ResourcesSection;
